import { render, staticRenderFns } from "./AccountDeliveryCostView.vue?vue&type=template&id=305c382d&scoped=true&"
import script from "./AccountDeliveryCostView.vue?vue&type=script&lang=ts&"
export * from "./AccountDeliveryCostView.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDeliveryCostView.vue?vue&type=style&index=0&id=305c382d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c382d",
  null
  
)

export default component.exports